import { createSlice as createSliceToolkit } from '@reduxjs/toolkit';

export function createReducer(name, initialState, handlers) {
  // eslint-disable-next-line default-param-last
  return (state = initialState, { type, payload }) => {
    if (handlers[type]) {
      return handlers[type](state, payload);
    }
    return state;
  };
}

export function createSlice(name, initialState, reducers) {
  return createSliceToolkit({
    name,
    initialState,
    reducers
  });
}

export default createReducer;
